import React from "react";
import { Modal, Button } from "semantic-ui-react";

const CustomerMessages = (props) =>
(<Modal
  className={"dialog-confirm-action"}
  closeIcon
  open={props.active}
  onClose={() => props.dialogClose(this)}
>
  <Modal.Header>{props.title}</Modal.Header>
  <Modal.Content image scrolling>
    <Modal.Description>{props.messages && props.messages.map((message, index) => <p key={`message_${index}`}>{message.Message}</p>)}</Modal.Description>
  </Modal.Content>
  <Modal.Actions className={"dialog-actions margin-bottom-15"}>
    <div className={"float-right"}>
      <Button
        className={"no-background-color"}
        onClick={() => props.dialogClose(this)}
      >
        OK
      </Button>
    </div>
  </Modal.Actions>
</Modal>
);


export default CustomerMessages;



// WEBPACK FOOTER //
// ./src/components/dialogs/CustomerMessages.js